// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__slEfO","code":"NotFound_code__bCEle","title":"NotFound_title__bcyuu"};